import { IconModule } from './../icon/icon.module';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PointComponent } from "./point.component";
import { HelpTextModule } from "../help-text/help-text.module";
import { LabelModule } from "../label/label.module";

@NgModule({
	declarations: [PointComponent],
	imports: [CommonModule, HelpTextModule, LabelModule, IconModule],
	exports: [PointComponent]
})
export class PointModule { }
